import { StyleSheet, css } from 'aphrodite'
import type React from 'react'
import type { AutoSaveStatus } from '../hooks/useAutoSave'
import AutoSaveIndicator from './AutoSaveIndicator'

interface ProjectHeaderProps {
  title: string
  date: string
  projectId?: string
  poNumber?: string
  step: number
  totalSteps: number
  autoSaveStatus?: AutoSaveStatus
  autoSaveLastSaved?: Date | null
}

const ProjectHeader: React.FC<ProjectHeaderProps> = ({
  title,
  date,
  projectId,
  poNumber,
  step,
  totalSteps,
  autoSaveStatus,
  autoSaveLastSaved,
}) => {
  return (
    <div className={css(styles.header)}>
      <div className={css(styles.topRow)}>
        <div className={css(styles.projectId)}>
          {projectId || (
            <span className={css(styles.loadingText)}>Loading...</span>
          )}
        </div>
        <span className={css(styles.date)}>{date}</span>
      </div>
      <h2 className={css(styles.title)}>{title}</h2>
      {poNumber && <div className={css(styles.poNumber)}>{poNumber}</div>}
      <div className={css(styles.stepIndicator)}>
        Step {step} of {totalSteps}
      </div>
      {autoSaveStatus && (
        <div className={css(styles.autoSaveRow)}>
          <AutoSaveIndicator
            status={autoSaveStatus}
            lastSaved={autoSaveLastSaved ?? null}
          />
        </div>
      )}
    </div>
  )
}

const styles = StyleSheet.create({
  header: {
    padding: '24px',
    borderBottom: '1px solid #E5E7EB',
    textAlign: 'center',
  },
  topRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  title: {
    margin: 0,
    marginBottom: '8px',
    fontSize: '24px',
    fontWeight: 600,
    textAlign: 'center',
  },
  date: {
    color: '#6B7280',
    fontSize: '14px',
  },
  projectId: {
    color: '#374151',
    fontSize: '14px',
    fontWeight: 700,
  },
  loadingText: {
    color: '#9CA3AF',
    fontStyle: 'italic',
    fontWeight: 400,
  },
  poNumber: {
    color: '#059669',
    fontSize: '16px',
    fontWeight: 500,
    marginBottom: '16px',
  },
  stepIndicator: {
    color: '#6B7280',
    fontSize: '14px',
  },
  autoSaveRow: {
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'center',
  },
})

export default ProjectHeader
